<footer class="govbook-footer">
  <nav aria-labelledby="footer-social-media-heading" class="nav--social-links">
    <h2 class="visually-hidden" id="footer-social-media-heading">Social Media</h2>
    <ul class="menu menu--social-media list--inline">
      <li class="menu-item">
        <a target="_blank" aria-label="Facebook (opens in new window)" class="social-link facebook"
          href="https://en-gb.facebook.com/lincolnshirecc/">Facebook</a>
      </li>
      <li class="menu-item">
        <a target="_blank" aria-label="X, formerly Twitter (opens in new window)" class="social-link twitter"
          href="https://twitter.com/lincolnshirecc">X (Twitter)</a>
      </li>
      <li class="menu-item">
        <a target="_blank" aria-label="Instagram (opens in new window)" class="social-link instagram"
          href="https://www.instagram.com/lincolnshirecc">Instagram</a>
      </li>
      <li class="menu-item">
        <a target="_blank" aria-label="LinkedIn (opens in new window)" class="social-link linkedin"
          href="https://www.linkedin.com/company/lincolnshire-county-council">LinkedIn</a>
      </li>
    </ul>
  </nav>

  <div class="govbook-footer__pre-footer">
    <div class="govuk-width-container">
      <nav class="site-footer__links-main" aria-label="Footer">
        <ul class="menu site-footer__list list--inline">
          <li class="menu-item">
            <a target="_blank" aria-label="Contact us (opens in new window)" rel="noopener noreferrer"
              class="footer-links" href="https://www.lincolnshire.gov.uk/comments-feedback/contact-us">Contact us</a>
          </li>
          <li class="menu-item">
            <a target="_blank" aria-label="Cookies (opens in new window)" rel="noopener noreferrer"
              class="footer-links" href="https://www.lincolnshire.gov.uk/cookies">Cookies</a>
          </li>
          <li class="menu-item">
            <a target="_blank" aria-label="Accessibility (opens in new window)" rel="noopener noreferrer"
                class="footer-links" [routerLink]="['/accessibility-statement']">Accessibility</a>
          </li>
          <li class="menu-item">
            <a target="_blank" aria-label="Privacy (opens in new window)" rel="noopener noreferrer"
              class="footer-links" href="https://www.lincolnshire.gov.uk/privacy">Privacy</a>
          </li>
          <li class="menu-item">
            <a target="_blank" aria-label="Modern slavery statement (opens in new window)" rel="noopener noreferrer"
              class="footer-links" href="https://www.lincolnshire.gov.uk/modernslavery">Modern slavery statement</a>
          </li>
        </ul>
      </nav>

      <div class="identity">
        <img src="assets/lincolnshire-logo.svg" alt="Lincolnshire County Council logo" class="logo">
      </div>
    </div>
  </div>

  <div class="site-footer__rights-container">
    <div class="govbook-container">
      <span class="site-footer__text">Powered by
        <a target="_blank" aria-label="Bookinglab | GovBook (opens in new window)" class="footer-links"
          href="https://www.bookinglab.co.uk/solutions/gov-book/registrars-and-ceremonies-booking-system/?utm_source=clientbrowser&utm_medium=clientbookingjourney&utm_campaign=registrarsbooking&utm_content=lincolnshire">bookinglab | GovBook</a></span>
    </div>
  </div>
</footer>
